import settings from '@api/routes/ccde-api/get-appt-flow-settings';
import getChallenge from '@api/routes/ccde-api/get-challenge';
import getAgreement from '@api/routes/ccde-api/get-agreement';
import getHospitals from '@api/routes/ccde-api/get-hospitals'
import agree from '@api/routes/ccde-api/agree-post';
import enroll from '@api/routes/ccde-api/enroll-post';
import confirmChallenge from '@api/routes/ccde-api/confirm-challenge';
//import createNewClientapi from '@api/routes/ccde-api/createNewClient';
import getPlan from '@api/routes/ccde-api/get-plan';
import expireMembership from '@api/routes/ccde-api/expire-membership';
import * as templates from './templates';
import * as createEl from './ccde-create-elements';

//import firstdataMock from './mock-fist-ava-response.json';
//import datejsonMock from './mock-date-time-response.json';

var VCA = VCA || {};

//var firstdata = firstdataMock;
//var datejson = datejsonMock;

var timesToTry = 1;


VCA.CareClubForm = (function ($) {

    var ui = {};

    var careClubInfo = {
        'hospitalIDValue': '',
        'hospitalName': '',
        'hospitalType': '',
        'isLoggedIn': '',
        'petName': 'pet',
        'petGender': '',
        'sexId': '',
        'petSpayed': '',
        'petSpecies': '',
        'speciesId': '',
        'petsAgeYear': '',
        'petsAgeMonth': '',
        'petAgeDataLayerFormat': '',
        'petBreed': '',
        'petBreedId': '',
        'isPrimaryHospital': '',
        'firstName': '',
        'lastName': '',
        'address': '',
        'address2': '',
        'city': '',
        'state': '',
        'zip': '',
        'email': '',
        'phone': '',
        'phoneDigitsOnly': '',
        'petId': '0',
        'challengeSuccessful':false,
        'challengeSetId': '',
        'addressChallengeId':'',
        'addressChallengeAnswer': '',
        'petNameChallengeId':'',
        'petNameChallengeAnswer':'',
        'isNewClient': 'null',
        'clientId': '0',
        'challengeClientId': '',
        'petImgURL':'',
        'isCareClubMember':'',
        'clientInfo':'',
        'planid': '',
        'utm_campaign': '',
        'utm_content': '',
        'utm_medium': '',
        'utm_source': '',
        'utm_term': '',
        'gclid': '',
        'petInfo':[],
        'existPet':[],
        'breedsList':[],
        'hospitalType': '',
        'hospitalPhoneNumber': '',
        'requestAnAppointmentUrl': '',
        'bookAnAppointmentUrl': '',
        'zipLat': '',
        'zipLong': '',
        'zipRadius': '',
        'membershipId': ''
    }

    function cacheUI() {
        ui.$welcome = $('section[data-step="welcome"]');
        ui.$selectExistPet = $('section[data-step="select-pet"]');
        ui.$preSigned = $('section[data-step="existing-memeber"]');
        ui.$getInTouch = $('section[data-step="get-in-touch"]');
        ui.$healthStatus = $('section[data-step="health-status"]');
        ui.$petReview = $('section[data-step="info-hospital-review"]');
        ui.$confirmInfo = $('section[data-step="owner-info"]');
        ui.$confirmation = $('section[data-step="confirmation"]');
        ui.$agreement = $('section[data-step="agreement"]');
        ui.$petInfo =$('section[data-step="pet-info"]');
        ui.$serviceStep =$('section[data-step="plan"]');
        ui.$errorStep = $('section[data-step="error"]');
        ui.$selectPet = $('section[data-step="pet-type-name"]');
        ui.$verifyStep = $('section[data-step="verification"]');
        ui.$hospitalSelector = $('section[data-step="hospital-selector"]');
        ui.$incorrect = $('section[data-step="incorrect-answers"]');
        ui.$progressBar = $('div[data-progress="bar"]');
        ui.$sections = $('.js-seciton-step');
        ui.$backBtn = $('button[data-btn="back"]');
        ui.$abandonLink = $('.js-abandon-link');
        ui.$cancelBtn = $('.js-cancel-btn');
        ui.$loginLink = $('.js-login-link');
        ui.loader = $('.js-loader');
        ui.hospitalLoader = $('.js-hospital-loader');
        ui.vetSlotList = $('.js-vet-slot-list');
        ui.$confirmationBtnsContainer = $('.ccde__confirmation-buttons');
        ui.$hospitalPhoneNum = $('.ccde-hospital-phonenum');
        ui.$geocoder;
        ui.$expireMembershipBtn = $('.js-expire-membership');
        ui.isCanada = $('[data-iscanada]').attr('data-iscanada');
    }

    function init() {
        if ($('.ccde__wrapper').length <= 0) {
            return;
        };
        // Loaded via <script> tag, create shortcut to access PDF.js exports.
        var pdfjsLib = window['pdfjs-dist/build/pdf'];

        // The workerSrc property shall be specified.
        pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';

        cacheUI();
        initOABForm();
        bindGoToStepClick();
        bindWelcomeClick();
        bindactiveBtnClick();
        bindSeclectHealthClick();
        bindPetInfoClick();
        bindpetConfirmClick();
        bindPetGenderClick();
        bindPetSpayedClick();
        bindClientInfoFormClick();
        bindVerifyUserClick();
        scrollTrems();
        bindfieldUpdate();
        bindServiceTypeClick();
        bindSelectPetClick();
        bindSeclectExistPetClick();
        bindSeclectPetContinueClick();
        bindComfirmPlanClick();
        bindAcceptClick();
        //bindOtherPetClick();
        bindNewClientClick()
        closeListbox();
        showLoader();
        bindHoverAgreementButton();
        bindAbandonCloseClick();
        bindHospitalAction();
        bindHospitalSelect();
        bindChangeHospitalClick();
        bindExpireMembershipClick();
        bindBackBtnClick();
    }

    async function initOABForm() {
        if(ui.$welcome.attr('data-attr-hospId') != null){
            careClubInfo.hospitalIDValue = ui.$welcome.attr('data-attr-hospId');
        }
        careClubInfo.hospitalType = ui.$welcome.attr('data-attr-hospType');
        careClubInfo.zipRadius = ui.$welcome.attr('data-attr-zipRadius');

        if(window.location.href.match(/\?./)){
            const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));

            for(const [ key, value ] of urlParams.entries()){
                careClubInfo[key] = value;

                if(key == 'returnUrl'){
                    ui.$abandonLink.attr("href", value);
                }
            }
        }

        showLoader();


        var params = {hospitalId:careClubInfo.hospitalIDValue};

        const { success, data, error }  = await settings.query(params);
        let response = data
        //console.log('Response: ',response);
        if(!success){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            hideLoader();
            $('.js-error-message').text(error);
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'error', '');
            return;
        }

        careClubInfo.isLoggedIn = response.IsLoggedIn;
        careClubInfo.isPrimaryHospital = response.IsPrimaryHospital;
        careClubInfo.hospitalName = response.HospitalName;
        let petTypes = response.Species;
        careClubInfo.breedsList = response.Breeds;
        careClubInfo.hospitalType = response.HospitalType;
        careClubInfo.hospitalPhoneNumber = response.HospitalPhoneNumber;
        careClubInfo.requestAnAppointmentUrl = response.RequestAnAppointmentUrl;
        careClubInfo.bookAnAppointmentUrl = response.BookAnAppointmentUrl;

        ui.$hospitalPhoneNum.attr('href',`tel:+${careClubInfo.hospitalPhoneNumber}`);
        ui.$hospitalPhoneNum.html(careClubInfo.hospitalPhoneNumber);

        if(careClubInfo.hospitalType != null){
            createDynamicRedirectButtons();
        }

       // let healthBtn = response.HealthStatus;

       // console.log(response);

        if(careClubInfo.isLoggedIn){
            $('.ccde__wrapper').addClass('js-logged-in-user');
            careClubInfo.existPet = response.Client.Pets;
            careClubInfo.clientInfo = response.Client;
            careClubInfo.clientId = response.Client.ClientId;
            ui.$loginLink.addClass('hidden');

            //create existing pet buttons
            let existPetBody = ui.$selectExistPet.find( ".ccde__form__body" );
            createEl.createExistPetBtns( careClubInfo.existPet, existPetBody);
            createPersonalInfoStep();
            //createPetIfoConfirm();
        }else{
            $('.ccde__wrapper').addClass('js-non-logged-in-user');
        }


        //  createHealthStatusBtns(healthBtn);
        //  let healthBody = ui.$healthStatus.find( ".ccde__form__body" );
        //  createEl.createHealthBtns(healthBtn, healthBody);

        //create pet buttons
        let petTypetBody = ui.$selectPet.find( ".ccde__form__body" );
        let othersList = ui.$selectPet.find( ".js-vca-dropdown-list" );
        createEl.createPetTypeBtns(petTypes, petTypetBody, othersList);

        hideLoader();
        window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'welcome', '');

    };

    async function getHospitalSettings() {
        var params = {hospitalId:careClubInfo.hospitalIDValue};

        const { success, data, error }  = await settings.query(params);
        let response = data
        //console.log('Response: ',response);
        if(!success){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            $('.js-error-message').text(error);
            hideLoader();
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'error', '');
            return;
        }else{
            ui.$sections.hide();
            careClubInfo.hospitalName = response.HospitalName;
            careClubInfo.hospitalType = response.HospitalType;
            careClubInfo.hospitalPhoneNumber = response.HospitalPhoneNumber;
            careClubInfo.requestAnAppointmentUrl = response.RequestAnAppointmentUrl;
            careClubInfo.bookAnAppointmentUrl = response.BookAnAppointmentUrl;

            ui.$hospitalPhoneNum.attr('href',`tel:+${careClubInfo.hospitalPhoneNumber}`);
            ui.$hospitalPhoneNum.html(careClubInfo.hospitalPhoneNumber);
    
            if(careClubInfo.hospitalType != null){
                createDynamicRedirectButtons();
            }
    
            ui.$petReview.show();
            updateProgresBar('info-hospital-review');
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'info-hospital-review', 'hospital-selector');
            hideLoader();
        }
    }

    async function initGetChallenge() {
        //console.log(careClubInfo);
        var params = {
            HospitalId:careClubInfo.hospitalIDValue,
            FirstName:careClubInfo.firstName,
            LastName:careClubInfo.lastName,
            Address1: careClubInfo.address,
            Address2: careClubInfo.address2,
            City: careClubInfo.city,
            StateCode: careClubInfo.state,
            Zip: careClubInfo.zip,
            PhoneNumber: careClubInfo.phoneDigitsOnly,
            Email:careClubInfo.email,
            PetAge: careClubInfo.petAge,
            PetName: careClubInfo.petName,
            SexId: careClubInfo.sexId,
            SpeciesId: careClubInfo.speciesId,
            BreedId: careClubInfo.petBreedId,

        };
      //  console.log(params);
        const { success, data, error }  = await getChallenge.post(params);
       // console.log(data, success, error);
        if(!success){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            hideLoader();
            $('.js-error-message').text(error);
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'error', 'owner-info');
            return;
        }
        let response = data
        // console.log('challenge' , response);
        if (response.IsExisting && response.ChallengeResponse != null && response.ChallengeResponse.petNameChallenge != null) {
            careClubInfo.clientId = response.ClientId;
            careClubInfo.challengeSetId = response.ChallengeResponse.id;
            careClubInfo.petNameChallengeId = response.ChallengeResponse.petNameChallenge.id;

            if(response.ChallengeResponse.addressChallenge != null){
                careClubInfo.addressChallengeId = response.ChallengeResponse.addressChallenge.id;
                let nog = response.ChallengeResponse.addressChallenge.gapLength;
                let n = response.ChallengeResponse.addressChallenge.gapLength;
                let spaces = new Array(++n).join('*');
                let address = response.ChallengeResponse.addressChallenge.preGap + spaces + response.ChallengeResponse.addressChallenge.postGap;
                $('.js-verify-address').text(address);
            }else{
                $('.js-verify-address-inputs').hide();
                $('.js-verify-address-inputs input[name="missingAddress"]').val('null')
            }

            //console.log('pet' , response.petNameChallenge.choices);

            let verifyBody = ui.$verifyStep.find(".js-pet-selector-box");
            verifyBody.empty();
            createEl.createVerifyInputs(response.ChallengeResponse.petNameChallenge.choices, verifyBody);

            ui.$verifyStep.on('keyup change', 'input', function (e) {
                if ($('.js-verify-address-inputs input[name="missingAddress"]').val().length != '' && $('.js-pet-selector-box input').is(':checked')) {
                    $('.js-verify-user').removeClass('disabled');
                }else{
                    $('.js-verify-user').addClass('disabled');
                }
            });
            ui.$sections.hide();
            ui.$verifyStep.show();
            hideLoader();
            updateProgresBar('verification');
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'Verification', 'owner-info');
        }else if(!response.IsExisting){
            careClubInfo.clientId = response.ClientId;
            careClubInfo.petId = response.PatientId;
            postEnrollPlan();
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'agreement', 'owner-info');
        }else{
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            hideLoader();
            $('.js-error-message').text(error);
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'error', 'owner-info');
            return;
        }

    }

    async function checkConfirmChallenge() {
        var params = {
            HospitalId:careClubInfo.hospitalIDValue,
            ClientId:careClubInfo.clientId,
            ChallengeSetId:careClubInfo.challengeSetId,
            AddressChallengeId:careClubInfo.addressChallengeId,
            AddressChallengeAnswer:careClubInfo.addressChallengeAnswer,
            PetNameChallengeId:careClubInfo.petNameChallengeId,
            PetNameChallengeAnswer:careClubInfo.petNameChallengeAnswer
        };
       // console.log(params);
        const { success, data, error }  = await confirmChallenge.post(params);
        let response = data;

        if(success && response.ChallengeSuccessful){
            careClubInfo.challengeSuccessful = true;
            careClubInfo.isLoggedIn = true;

            clearPetInformation();

            careClubInfo.existPet = response.Settings.Client.Pets;
           // careClubInfo.clientInfo = response.Client;
            careClubInfo.clientId = response.Settings.Client.ClientId;

            //create existing pet buttons
            let existPetBody = ui.$selectExistPet.find( ".ccde__form__body" );
            createEl.createExistPetBtns( careClubInfo.existPet, existPetBody);
            ui.$sections.hide();
            ui.$selectExistPet.show();
            hideLoader();
            updateProgresBar('select-pet');
            ui.$selectExistPet.find('button[data-btn="back"]').hide();
            careClubInfo.isLoggedIn = true;
            $('.ccde__wrapper').removeClass('js-non-logged-in-user');
            $('.ccde__wrapper').addClass('js-logged-in-user');
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'Select pet', 'Verification');
        }
        else if (success && !response.ChallengeSuccessful){
            ui.$sections.hide();
            ui.$incorrect.show();
            hideLoader();
            careClubInfo.clientId = '0';
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'incorrect-answers', 'Verification');
        }
        else {
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            hideLoader();
            $('.js-error-message').text(error);
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'error', 'Verification');
            return;
        }
    }

    async function createNewClient() {
        var params = {
            HospitalId:careClubInfo.hospitalIDValue,
            ClientId:careClubInfo.clientId
        };
       // console.log(params);
        //const { success, data, error }  = await createNewClientapi.post(params);
        let response = data;

        if(success){

            careClubInfo.clientId = response.ClientId;
            careClubInfo.petId = response.PatientId;
            postEnrollPlan();

        }
        else {
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            hideLoader();
            $('.js-error-message').text(error);
            return;
        }
    }

    async function getPlanDetails() {

        showLoader();
        var params = {
            HospitalId:careClubInfo.hospitalIDValue,
            PetAgeMonths: careClubInfo.petAge,
            SpeciesId: careClubInfo.speciesId,
            SexId: careClubInfo.sexId,
            BreedId: careClubInfo.petBreedId
        };
        // console.log(careClubInfo);
        // console.log(params);

        const { success, data, error }  = await getPlan.post(params);
        //console.log(data);
        if(!success || data.IsSuccess == false ){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            hideLoader();
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'error', 'info-hospital-review');
            $('.js-error-message').text(data.InputErrorMessages);
            return;
        }else{
         //   console.log(data);
            careClubInfo.planid = data.PlanId
            createPlanStep(data)
        }
    }

    function createPlanStep(planInfo) {

        let services = planInfo.Services;
        ui.$serviceStep.find( ".js-plan-name" ).text(planInfo.PlanName);
        ui.$serviceStep.find( ".js-init-fee" ).text(planInfo.InitiationFee);
        ui.$serviceStep.find( ".js-month-fee" ).text(planInfo.MonthlyPrice);
        ui.$serviceStep.find( ".js-annual-fee" ).text(planInfo.AnnualPrice);

        let serviceList = ui.$serviceStep.find( ".js-service-list" );
        let servicesDesc = ui.$serviceStep.find( ".js-service-list-desc" );
        createEl.createServiceBtn(services, serviceList, servicesDesc);
        ui.$sections.hide();
        ui.$serviceStep.show();
        hideLoader();

    }

    function closeListbox() {
        $(document).on( "mouseup touchend", function(e){
            var container = $(".vca-dropdown-select");

            // If the target of the click isn't the container
            if(!container.is(e.target) && container.has(e.target).length === 0){
                let listBox = $('.vca-dropdown-select');
                let listButton = listBox.find('.js-btn-selecter');
                listBox.find('.js-vca-dropdown-list').addClass('hidden');
                listButton.attr("aria-expanded","false");
            }
        });
    }

    function updateSeciton(targetValue) {
        ui.$sections.hide();
        $('section[data-step="' + targetValue + '"').show();
        hideLoader();
        updateProgresBar(targetValue);
    }

    function updateProgresBar(targetValue) {
        var progressValue = $('section[data-step="' + targetValue + '"').attr('data-progress');
        if (targetValue === "welcome") {
            ui.$progressBar.hide();
        }
        if (targetValue === "select-pet" || targetValue === "pet-type-name" ) {
            ui.$progressBar.show();
        }
        $('.progress-bar').css('width', progressValue+'%').attr('aria-valuenow', progressValue);
    }

    function updateBackBtn(targetValue, backStepValue) {
        $('section[data-step="' + targetValue + '"]').find('button[data-btn="back"]').attr('data-target', backStepValue);
    }

    function bindBackBtnClick(){
        ui.$backBtn.on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('btn-reset')) {
                resetDynamicTitle();
                $(this).closest('section[data-step]').find('.js-btn-selecter').removeClass('active').show();
                $(this).closest('section[data-step]').find('.js-hidden-step').hide();
                $(this).closest('section[data-step]').find('.js-shelter-link').show();
                $(this).closest('section[data-step]').find('.js-login-link').show();
                $(this).closest('section[data-step]').removeClass('part-two');
                $(this).removeClass('btn-reset');
                if($(this).hasClass('remove-on-next')) {
                    $(this).removeClass('remove-on-next');
                    $(this).hide();
                }
                return;
            }

            var targetValue = $(this).attr('data-target');
            updateSeciton(targetValue);
        });
    }

    function bindSeclectPetContinueClick() {
        $('.js-select-btn-contiune').on('click', function (e) {
            e.preventDefault();
            var wrap = $(this).closest('.ccde__form__body');
            if ( wrap.find('.js-required').val() === ''){
                wrap.find('.js-required').trigger('focus');
                return;
            }
            var newPetName = $('#petName').val();
            let petNameDisplay = '';
            if (newPetName.length > 37) {
                petNameDisplay = 'your pet';
            }else {
                petNameDisplay = newPetName;
            }
            $('.js-pet-name').each(function() {
                $(this).text(petNameDisplay);
            });
            careClubInfo.petName = newPetName;
            var targetValue = $(this).attr('data-target');
            let backStepValue = 'pet-type-name';
            updateBackBtn(targetValue, backStepValue);
            updateSeciton(targetValue);
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'pet-info', 'Pet type and name');
        });
    }
    
    function bindHospitalSelect() {
        $('.js-seciton-step').on('change', '.js-hospital-list input', function (e) {
            
            if ($('.js-hospital-list input').is(':checked')) {
                $('.js-hospital-select-btn').removeClass('disabled');
            }else{
                return;
            }
        });
    }

    function bindHospitalAction() {
        $('.js-seciton-step').on('keyup', '.js-pet-type-btn input, .js-hospital-zip', function (e) {
            e.preventDefault();
            let inputZip = $('.js-hospital-zip')
            let zipValue = inputZip.val();

            if (zipValue.length === 5) {
                searchInProgress(true);
                getCoordinates(zipValue);
            }else{
                inputZip.val(inputZip.val().substr(0,5));
                return;
            }
        });
    }

    function searchInProgress(isInProgess) {
        if(isInProgess){
            ui.hospitalLoader.show();
            $('.js-zipError').hide();
            $('.js-noResultsFound').hide();
            $('.ccde__select-hospital-wrap').addClass('-searching');
            $('.js-hospital-select-btn').addClass('disabled');
        }else {
            ui.hospitalLoader.hide();
            $('.ccde__select-hospital-wrap').removeClass('-searching');
            $('.js-hospital-zip').prop("disabled", false);
            $('.js-hospital-item').prop('checked', false);
        }
    }

    function getSearchBounds() {
        let Bounds = getBounds(careClubInfo.zipLat, careClubInfo.zipLong, careClubInfo.zipRadius);
        let coordinatesResult = calcMinMaxLatLng(Bounds);

        return coordinatesResult;
    }

    function getCoordinates(zip) {
        ui.$geocoder = new google.maps.Geocoder();

        ui.$geocoder.geocode({
            'address': zip
        }, function (results, status) {
          //  console.log('results', results);
            if (status == 'OK') {
                careClubInfo.zipLat = results[0].geometry.location.lat();
                careClubInfo.zipLong = results[0].geometry.location.lng();
                let coordinates = getSearchBounds();
                findHospitals(coordinates);
            } else {
                console.log('Geocode was not successful for the following reason: ' + status);
                searchInProgress(false);
                $('.js-zipError').show();
            }
        });
    }

    function getBounds(lat, lng, radius) {
        let ConvertedRadius = radius * 1609.34;

        // add to canada site
         if(ui.isCanada === 'true'){
             ConvertedRadius = radius * 1000;
         }

        var circleData = {
            center: {
                lat,
                lng
            },
            radius: ConvertedRadius
        };

        if (window['google']) {
            return new window['google'].maps.Circle(circleData).getBounds();
        }
    }

    function calcMinMaxLatLng(bounds) {
        var obj = {
            minLat: bounds.getNorthEast().lat(),
            maxLat: bounds.getSouthWest().lat(),
            minLng: bounds.getNorthEast().lng(),
            maxLng: bounds.getSouthWest().lng()
        }
        return obj;
    }

    async function findHospitals(coordinates) {
        //console.log('coordinates', coordinates);
        let hosptialDesc = $('.js-hospital-list');

        let payload = {
            minLat: coordinates.minLat,
            maxLat: coordinates.maxLat,
            minLong: coordinates.minLng,
            maxLong: coordinates.maxLng,
            speciesid: careClubInfo.speciesId
            };
          //  console.log('payload', payload);

        const { success, data, error }  = await getHospitals.query(payload);
        let hospitals = data;
        console.log(data);
        if(!success){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            searchInProgress(false);
            $('.js-error-message').text(error);
            hideLoader();
            return;
        }
        else if(data == null || data == '' || data == undefined) {
            searchInProgress(false);
            $('.js-noResultsFound').show();
            hosptialDesc.hide();
        }
        else{
            createEl.createHospitalList(hospitals, hosptialDesc);
            searchInProgress(false);
            hosptialDesc.show();
        }
    }

    function createPersonalInfoStep() {

        if(careClubInfo.isLoggedIn) {
            let primaryEmail = '';
            $.each(careClubInfo.clientInfo.ClientEmails, function (i, email) {
                if(email.IsPrimary) {
                    primaryEmail =  email.Email;
                }
            });
            let primaryPhone = '';
            $.each(careClubInfo.clientInfo.ClientPhones, function (i, phone) {
                if(phone.IsPrimaryContact) {
                    primaryPhone =  phone.PhoneNumber;
                }
            });
            let primaryAddress = [];
            $.each(careClubInfo.clientInfo.Addresses, function (i, address) {
                if(address.IsMailingAddress) {
                    primaryAddress =  address;
                }
            });
            ui.$confirmInfo.find('#fname').val(careClubInfo.clientInfo.FirstName);
            ui.$confirmInfo.find('#lname').val(careClubInfo.clientInfo.LastName);
            ui.$confirmInfo.find('#email').val(primaryEmail);
            ui.$confirmInfo.find('#phone').val(primaryPhone);
            ui.$confirmInfo.find('#address').val(primaryAddress.AddressLine1);
            ui.$confirmInfo.find('#address2').val(primaryAddress.AddressLine2);
            ui.$confirmInfo.find('#city').val(primaryAddress.City);
            ui.$confirmInfo.find('#state').val(primaryAddress.State);
            ui.$confirmInfo.find('#zip').val(primaryAddress.ZipCode);
        }
    }

    function updatePetInfo(petId) {

            if(careClubInfo.isLoggedIn) {
                $.each(careClubInfo.existPet, function (i, pet) {
                    if(pet.id != '0' && pet.Id == petId) {
                        careClubInfo.petInfo =  pet;
                        careClubInfo.petName = careClubInfo.petInfo.Name
                        careClubInfo.petSpecies = careClubInfo.petInfo.SpeciesId
                        careClubInfo.speciesId = careClubInfo.petInfo.SpeciesId
                        careClubInfo.petBreed = careClubInfo.petInfo.BreedNames
                        careClubInfo.petBreedId = careClubInfo.petInfo.Breeds.BreedId
                        careClubInfo.petAge = careClubInfo.petInfo.Age
                        careClubInfo.petAgeDataLayerFormat = careClubInfo.petInfo.Age
                        careClubInfo.petGender = careClubInfo.petInfo.Sex.Name
                        careClubInfo.sexId = careClubInfo.petInfo.SexId
                        careClubInfo.petSpayed = careClubInfo.petInfo.Neutered

                        let ageAry = careClubInfo.petInfo.Age.split(' ');
                        let months = '';
                        let weekToMonth = '';
                        let yearsandmonths = '';
                        $.each(ageAry,function(i , item){
                            if(item[item.length -1] == 'y'){
                                yearsandmonths = parseFloat(item.split('y')[0]) * 12;
                            }
                            if(item[item.length -1] == 'm'){
                                months = parseFloat(item.split('m')[0]);
                            }
                            if(item[item.length -1] == 'w'){
                                weekToMonth = parseFloat(item.split('w')[0]) / 4;
                            }

                        });
                        yearsandmonths = yearsandmonths + months;
                        careClubInfo.petsAgeMonth = parseFloat(yearsandmonths) + weekToMonth
                    }
                });
                ui.$petReview.find('.js-edit-pet-btn').hide();
                ui.$petReview.find('.js-edit-pet-name-btn').hide();

                if (careClubInfo.petSpecies == 1) {
                    $('.js-pet-type').text('Dog');
                } else if (careClubInfo.petSpecies == 2) {
                    $('.js-pet-type').text('Cat');
                } else {
                    $('.js-pet-type').text('Unspecified');
                }
            }else{
                ui.$petReview.find('.js-edit-pet-btn').show();
                ui.$petReview.find('.js-edit-pet-name-btn').show();

                $('.js-pet-type').text(careClubInfo.petSpecies);
            }

            $('.js-pet-name-wrapper').text(careClubInfo.petName);
            $('.js-pet-breed').text(careClubInfo.petBreed);
            $('.js-pet-age').text(careClubInfo.petAge);
            $('.js-pet-gender').text(careClubInfo.petGender);
            $('.js-pet-spayed').text(careClubInfo.petSpayed);
            $('.js-hospital-name').text(careClubInfo.hospitalName);
    }

    function bindGoToStepClick() {
        $('.js-seciton-step').on('click', 'button.js-next-btn', function (e) {
            e.preventDefault();
            var targetValue = $(this).attr('data-target');
            ui.$sections.hide();
            updateSeciton(targetValue);
            updateProgresBar(targetValue);
        });
    }

    function bindAbandonCloseClick() {
        $('.js-seciton-step').on('click', '.js-abandon-link, .js-cancel-btn, .btn-sky-outline-alt', function (e) {
            var wrap = $(this).closest('section[data-step]');
            let targetValue = wrap.attr('data-step');
            let btnName = $(this).text();
           // console.log('t',targetValue);
            window.VCA.ccdeDatalayer.datalayerPushAbandon(careClubInfo, targetValue, btnName);
        });
    }

    function bindWelcomeClick() {
        $('.js-seciton-step').on('click', 'button.js-welcome-btn', function (e) {
            e.preventDefault();

            if(careClubInfo.isLoggedIn){
                ui.$sections.hide();
                ui.$selectExistPet.show();
                ui.$progressBar.show();
                updateProgresBar('select-pet');
                window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'Select pet', 'welcome');
            }else {
                ui.$sections.hide();
                ui.$selectPet.show();
                ui.$progressBar.show();
                updateProgresBar('pet-type-name');
                window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'Pet type and name', 'welcome');
            }
        });
    }

    function bindSeclectExistPetClick() {
        $('.js-seciton-step').on('click', 'button.js-exist-pet-btn', function (e) {
            e.preventDefault();

           // console.log(careClubInfo);
            // clearPetInformation();
            let selectedPet = ui.$selectExistPet.find('.js-acitve-btn.active');
            var newPetName = selectedPet.attr('data-pet-name');
            var selectedPetGender = selectedPet.attr('data-genderid')
            let petNameDisplay = '';
            if (newPetName.length > 37) {
                petNameDisplay = 'your pet';
            }else {
                petNameDisplay = newPetName;
            }

            $('.js-pet-name').each(function() {
                $(this).text(petNameDisplay);
            });

            $('.js-sex-id').each(function() {
                if (selectedPetGender == 2) {
                    $(this).text('her');
                } else {
                    $(this).text('his');
                }
            });

            careClubInfo.petName = newPetName;
            careClubInfo.petId = selectedPet.attr('data-pet-id');
            careClubInfo.isCareClubMember = selectedPet.data('careclub');
            if(careClubInfo.isCareClubMember) {
                ui.$sections.hide();
                ui.$preSigned.show();
                updateProgresBar('existing-memeber');
                window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'Existing Memeber', 'Select Pet');
            }else{
                ui.$sections.hide();
                let healthPick = ui.$healthStatus.find('.js-acitve-btn.active');
                healthPick.removeClass('active');
                ui.$healthStatus.find('.js-status-btn').addClass('disabled');
                ui.$healthStatus.show();
                updateProgresBar('health-status');
                updatePetInfo(careClubInfo.petId);
                updateBackBtn('health-status', 'select-pet');
                window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'health-status', 'Select Pet');
            }
        });
    }

    function bindSeclectHealthClick() {
        $('.js-seciton-step').on('click', 'button.js-status-btn', function (e) {
            e.preventDefault();
            let healthPick = ui.$healthStatus.find('.js-acitve-btn.active');
            var isHealth = healthPick.attr('data-value');

            if(isHealth == 1) {
                ui.$sections.hide();
                ui.$getInTouch.show();
                updateProgresBar('get-in-touch');
                window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'get-in-touch', 'health-status');
            }else if(isHealth == 0) {
                ui.$sections.hide();
                if(careClubInfo.hospitalIDValue == null || careClubInfo.hospitalIDValue == '') {
                    ui.$hospitalSelector.show();
                    updateProgresBar('hospital-selector');
                    window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'hospital-selector', 'health-status');
                }else {
                    ui.$petReview.show();
                    var targetValue = 'info-hospital-review';
                    let backStepValue = 'health-status';
                    updateBackBtn(targetValue, backStepValue);
                    updateProgresBar('info-hospital-review');
                    window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'info-hospital-review', 'health-status');
                }
            }
        });
    }

    function bindChangeHospitalClick() {
        $('.js-seciton-step').on('click', 'button.js-hospital-select-btn', function (e) {
            e.preventDefault();

            let selectedHopital = $(".js-hospital-list input[name='hospital-result']:checked");
            careClubInfo.hospitalIDValue = selectedHopital.val();
            careClubInfo.hospitalName = selectedHopital.data('name');
            $('.js-hospital-name').text(careClubInfo.hospitalName);
            var targetValue = 'info-hospital-review';
            let backStepValue = 'hospital-selector';
            updateBackBtn(targetValue, backStepValue);
            showLoader();
            getHospitalSettings();
        })
    }

    function bindpetConfirmClick() {
        $('.js-seciton-step').on('click', 'button.js-confirm-pet-info', function (e) {
            e.preventDefault();
            showLoader();
            getPlanDetails();
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'plan', 'info-hospital-review');
        })
    }

   function bindClientInfoFormClick() {
        $('.js-seciton-step').on('click', 'button.js-client-info-form', function (e) {
            e.preventDefault();

            if(!checkPersonalForm()){
                return;
            }
            if(!careClubInfo.isLoggedIn || (careClubInfo.isLoggedIn && !careClubInfo.isPrimaryHospital)) {
                showLoader();
                initGetChallenge();
            }else{
                showLoader();
                ui.$sections.hide();
                ui.$selectPet.show();
                updateProgresBar('pet-type-name');
            }
        });
    }

    function bindComfirmPlanClick() {
        $('.js-seciton-step').on('click', 'button.js-comfirm-plan-btn', function (e) {
            e.preventDefault();

            if(careClubInfo.isLoggedIn){
                showLoader();
                postEnrollPlan();
                window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'agreement', 'plan');
            }else {
                ui.$sections.hide();
                ui.$confirmInfo.show();
                ui.$progressBar.show();
                updateProgresBar('owner-info');
                window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'owner-info', 'plan');
            }

        })
    }

    async function postEnrollPlan() {
      //  console.log(careClubInfo);
        var params = {
            HospitalId:careClubInfo.hospitalIDValue,
            ClientId:careClubInfo.clientId,
            PatientId:careClubInfo.petId,
            PlanId:careClubInfo.planid
         };
        // console.log('firing enroll', params);
         const { success, data, error }  = await enroll.post(params);
       //  console.log(data);
         if (!success) {
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            $('.js-error-message').text(data.GenericServiceErrorMessage);
            return;
        } else if (careClubInfo.isLoggedIn) {
            var targetValue = 'agreement';
            let backStepValue = 'plan';
            updateBackBtn(targetValue, backStepValue);
        } else {
            var targetValue = 'agreement';
            let backStepValue = 'owner-info';
            updateBackBtn(targetValue, backStepValue);
        }

        careClubInfo.membershipId = data;
        createAgreementStep();

    }

    async function postAgree() {
        var params = {
            HospitalId:careClubInfo.hospitalIDValue,
            PatientId:careClubInfo.petId
         };
        // console.log(params);
         const { success, data, error }  = await agree.post(params);
       //  console.log(data);
         if(!success){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            $('.js-error-message').text(data.GenericServiceErrorMessage);
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'error', 'agreement');
            return;
        }else {
            ui.$sections.hide();
            ui.$confirmation.show();
            hideLoader();
            updateProgresBar('confirmation');
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'confirmation', 'agreement');
        }

    }

    function bindAcceptClick() {
        $('.js-seciton-step').on('click', 'button.js-accept-agreement', function (e) {
            let agreementButton = $(e.currentTarget);
            if (!agreementButton.hasClass('disabled')) {
                showLoader();
                postAgree();
            }
        });
    }

    function bindHoverAgreementButton() {
        $('.js-seciton-step').on('mouseenter', 'button.js-accept-agreement.disabled', function (e) {
            let button = $(e.currentTarget);
            button.next('.ccde__client-info__tooltip').show();
            $('.ccde__agreement__desc').css('opacity', '0.5');
        });

        $('.js-seciton-step').on('mouseleave', 'button.js-accept-agreement.disabled', function (e) {
            let button = $(e.currentTarget);
            button.next('.ccde__client-info__tooltip').hide();
            $('.ccde__agreement__desc').css('opacity', '1');
        });
    }

    async function createAgreementStep() {

        var params = {
            HospitalId:careClubInfo.hospitalIDValue,
            PatientId: careClubInfo.petId,
            clientId: careClubInfo.clientId
        };
        const { success, data, error }  = await getAgreement.post(params);
        if(!success && timesToTry > 5){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            hideLoader();
            $('.js-error-message').text(data.InputErrorMessages);
            return;
        }
        else if(!success && timesToTry < 6){
            timesToTry++;
            setTimeout(function() { 
                createAgreementStep();
            }, 500);
        }
        else{
          //  ui.$agreement.find( ".js-agreement-text" ).text(data.Terms);
            $('.js-print-pdf').attr("href", data);
            let pdfData = window.atob(data.split(',')[1]);
            //console.log(pdfData);
            //var loadingTask = pdfjsLib.getDocument({data: pdfData});

            var pdfDoc = null,
                pageNum = 1,
                pageRendering = false,
                pageNumPending = null,
                scale = 2,
                canvas = document.getElementById('the-canvas'),
                ctx = canvas.getContext('2d');

            /**
             * Get page info from document, resize canvas accordingly, and render page.
             * @param num Page number.
             */
            function renderPage(num) {
                pageRendering = true;
                // Using promise to fetch the page
                pdfDoc.getPage(num).then(function(page) {
                var viewport = page.getViewport({scale: scale});
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                // Render PDF page into canvas context
                var renderContext = {
                    canvasContext: ctx,
                    viewport: viewport
                };
                var renderTask = page.render(renderContext);

                // Wait for rendering to finish
                renderTask.promise.then(function() {
                    pageRendering = false;
                    if (pageNumPending !== null) {
                    // New page rendering is pending
                    renderPage(pageNumPending);
                    pageNumPending = null;
                    }
                });
                });

                if (num >= pdfDoc.numPages) {
                    $('.js-accept-agreement').removeClass('disabled');
                } else {
                    $('.js-accept-agreement').addClass('disabled');
                }

                // Update page counters
                document.getElementById('page_num').textContent = num;
            }

            /**
             * If another page rendering in progress, waits until the rendering is
             * finised. Otherwise, executes rendering immediately.
             */
            function queueRenderPage(num) {
                if (pageRendering) {
                pageNumPending = num;
                } else {
                renderPage(num);
                }
            }

            /**
             * Displays previous page.
             */
            function onPrevPage() {
                if (pageNum <= 1) {
                return;
                }
                pageNum--;
                queueRenderPage(pageNum);
            }
            document.getElementById('prev').addEventListener('click', onPrevPage);

            /**
             * Displays next page.
             */
            function onNextPage() {
                if (pageNum >= pdfDoc.numPages) {
                    return;
                }
                pageNum++;
                queueRenderPage(pageNum);
            }
            document.getElementById('next').addEventListener('click', onNextPage);
            /**
             * Asynchronously downloads PDF.
             */
            pdfjsLib.getDocument({data: pdfData}).promise.then(function(pdfDoc_) {
                pdfDoc = pdfDoc_;
                document.getElementById('page_count').textContent = pdfDoc.numPages;

                // Initial/first page rendering
                renderPage(pageNum);
            });

            ui.$sections.hide();
            ui.$agreement.show();
            hideLoader();
            updateProgresBar('agreement');
        }

    }

    function checkPersonalForm() {
            var mailFormat = /(^[a-zA-Z0-9_.]+[@]{1}[a-zA-Z0-9\-]+[\.][a-zA-Z]+$)/;
            var phoneReg = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
            var textReg = /^[a-zA-Z -]{2,60}$/;
            var zipReg = /^(\d{5})(?:-?(\d{4}))?$/;

            let valid = true
            careClubInfo.address2 = $('#address2').val();

            $('.ccde__client-info input.js-required').each(function (index) {
                let el = $(this);
                var elmId = el.attr("id");
                if (elmId == 'phone') {
                    let phone = $('#phone').val();
                    if (!phoneReg.test(phone)) {
                        el.addClass('error');
                        el.closest('.form-label-group').addClass('error');
                        valid = false;
                    } else {
                        el.removeClass('error');
                        el.closest('.form-label-group').removeClass('error');
                        careClubInfo.phone = el.val();
                        careClubInfo.phoneDigitsOnly = careClubInfo.phone.replace(/\D+/g, "");
                    }
                } else if (elmId == 'email') {
                    let email = $('#email').val();
                    if (!mailFormat.test(email)) {
                        el.addClass('error');
                        el.closest('.form-label-group').addClass('error');
                        valid = false;
                    } else {
                        el.removeClass('error');
                        el.closest('.form-label-group').removeClass('error');
                        careClubInfo.email = el.val();
                    }
                }else if (elmId == 'zip') {
                    let inputZip = el.val();
                    if (!zipReg.test(inputZip)) {
                        el.addClass('error');
                        el.closest('.form-label-group').addClass('error');
                        valid = false;
                    } else {
                        el.removeClass('error');
                        el.closest('.form-label-group').removeClass('error');
                        careClubInfo.zip = el.val();
                    }
                }
                else if (elmId == 'fname') {
                    let fname = el.val();
                    if (!textReg.test(fname)) {
                        el.addClass('error');
                        el.closest('.form-label-group').addClass('error');
                        valid = false;
                    } else {
                        el.removeClass('error');
                        el.closest('.form-label-group').removeClass('error');
                        careClubInfo.firstName = el.val();
                    }
                }
                else if (elmId == 'lname') {
                    let lname = el.val();
                    if (!textReg.test(lname)) {
                        el.addClass('error');
                        el.closest('.form-label-group').addClass('error');
                        valid = false;
                    } else {
                        el.removeClass('error');
                        el.closest('.form-label-group').removeClass('error');
                        careClubInfo.lastName = el.val();
                    }
                }
                 else {
                    if (el.val() == '') {
                        el.addClass('error');
                        el.closest('.form-label-group').addClass('error');
                        valid = false;
                    } else {
                        el.removeClass('error');
                        el.closest('.form-label-group').removeClass('error');
                        careClubInfo[elmId] = el.val();
                    }
                }
            });

            $('.ccde__client-info .select-box__select').each(function (index) {
                let el = $(this);
                if (el.val() == '' || el.val() == null) {
                    el.addClass('error');
                    el.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    el.removeClass('error');
                    el.closest('.form-label-group').removeClass('error');
                    var elmId = el.attr("id");
                    careClubInfo[elmId] = el.val();
                }
            });

            return valid;
    }

    function checkPetInfoForm() {

        let valid = true
        let ageValue = '';
        let ageDataFormat = '';

        if($("#breed").val() === ""){
            $('#breed').addClass('error');
            $('#breed').closest('.form-label-group').addClass('error');
            valid = false;
        }else{
            $('#breed').removeClass('error');
            $('#breed').closest('.form-label-group').removeClass('error');
            careClubInfo.petBreed = $('#breed').val();
            careClubInfo.petBreedId = $('#breed').find(':selected').data('id');
        }

        if($('#month').val() + $("#year").val() < 1){
            $('#year').addClass('error');
            $('#year').closest('.form-label-group').addClass('error');
            $('#month').addClass('error');
            $('#month').closest('.form-label-group').addClass('error');
            valid = false;
            ageValue += $('#month').val() + 'm';
        }else {
            $('#year').removeClass('error');
            $('#year').closest('.form-label-group').removeClass('error');
            $('#month').removeClass('error');
            $('#month').closest('.form-label-group').removeClass('error');
            if($('#year').val() > 0){
                ageValue = $('#year').val() + 'y ';
            }
            if($('#month').val() > 0){
                ageValue += $('#month').val() + 'm';
            }
            ageDataFormat = $('#year').val() + 'y ' + $('#month').val() + 'm';
            let yearsInMounths = parseFloat($('#year').val() * 12);
            careClubInfo.petsAgeMonth =  yearsInMounths + parseFloat($('#month').val());
            careClubInfo.petAge = ageValue;
            careClubInfo.petAgeDataLayerFormat = ageDataFormat;
            console.log('ageDataFormat', ageDataFormat);
        }

        if(careClubInfo.petGender == ''){
            $('.js-gender-group').addClass('error');
            valid = false;
        }else {
            $('.js-gender-group').removeClass('error');
        }
        // Future release
        /* if(careClubInfo.petSpayed == ''){
            $('.js-spayed-group').addClass('error');
            valid = false;
        }else{
            $('.js-spayed-group').removeClass('error');
        } */

       // console.log(careClubInfo.petAge);

        return valid;
    }

    function bindPetInfoClick() {
        $('[data-step="pet-info"]').on('click', '.js-pet-info-form', function (e) {
            e.preventDefault();

            if(!checkPetInfoForm()){
                return;
            }

            ui.$sections.hide();
            ui.$healthStatus.show();
            updateProgresBar('health-status');
            updatePetInfo(careClubInfo.petId);
            updateBackBtn('health-status', 'pet-info');
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'health-status', 'pet-info');
        });
    }

    function bindactiveBtnClick() {
        $('.js-seciton-step').on('click', '.js-acitve-btn', function (e) {
            e.preventDefault();
            $(this).closest('.ccde__form__body').find('button.active').removeClass('active');
            $(this).addClass('active');
            $(this).closest('.ccde__form__body').find('button.disabled').removeClass('disabled');
        });
    }

    function bindPetGenderClick() {
        $('[data-step="pet-info"]').on('click', '.js-gender-group .btn-selecter', function (e) {
            e.preventDefault();
            $('.js-gender-group').find('.btn-selecter').removeClass('active');
            careClubInfo.petGender = $(this).data('gender');
            careClubInfo.sexId = $(this).data('genderid');
            $('.js-sex-id').each(function() {
                if (careClubInfo.sexId == 1) {
                    $(this).text('his');
                } else if (careClubInfo.sexId == 2) {
                    $(this).text('her');
                }
            });
            $(this).addClass('active');
        });
    }

    function bindPetSpayedClick() {
        $('[data-step="pet-info"]').on('click', '.js-spayed-group .btn-selecter', function (e) {
            e.preventDefault();
            $('.js-spayed-group').find('.btn-selecter').removeClass('active');
            careClubInfo.petSpayed = $(this).data('spayed');
            $(this).addClass('active');
        });
    }

    function scrollTrems() {
        if($('.js-agreement-text')[0].scrollHeight >  $('.js-agreement-text').height()){
            $('.js-agreement-text').on('scroll', function () {
                let newHeight = $(this)[0].scrollHeight * .92;
               if ($(this).scrollTop() + $(this).innerHeight() +2 >= newHeight) {
                    $('.js-accept-agreement').removeClass('disabled');
                }
            });
        }
        else{
            $('.js-accept-agreement').removeClass('disabled');
        }
    }

    function bindServiceTypeClick() {
        $('.js-service-list').on('click', '.js-service-option', function (e) {
            e.preventDefault();
            var serviceType = $(this).attr('data-option');
            if($(this).hasClass('active')){
                $('.js-service-option').removeClass('active');
                $('.js-service-desc').hide();
            }else {
                $('.js-service-option').removeClass('active');
                $(this).addClass('active');
                $('.js-service-desc').hide();
                $('.js-service-desc[data-desc="' + serviceType +'"]').show();
            }
        });
    }

    function bindfieldUpdate() {
        $('[data-step="pet-type-name"] .js-required').on('keyup', function (e) {
            e.preventDefault();
            var wrap = $(this).closest('.ccde__form__body');
            if($(this).val() !== '') {
                wrap.find('.js-btn-required').removeClass('disabled');
            }else if($(this).val() === '') {
                wrap.find('.js-btn-required').addClass('disabled');
            }
        });
    }


    function createDynamicRedirectButtons() {

        ui.$confirmationBtnsContainer.each((idx,wrapper) => {
            switch(careClubInfo.hospitalType) {
                case 0 :  //Nothing
                    break;
                case 1 : //Book
                    $(wrapper).html(`<a class="btn btn-sky-outline-alt active" href="${careClubInfo.bookAnAppointmentUrl}">Book an Appointment</a>`);
                    break;
                case 2 : //Request
                    $(wrapper).html(`<a class="btn btn-sky-outline-alt active" href="${careClubInfo.requestAnAppointmentUrl}">Request an Appointment</a>`);
                    break;
                case 3 : //Contact
                    $(wrapper).html(`<a class="btn btn-sky-outline-alt active" href="tel:+${careClubInfo.hospitalPhoneNumber}">Call Us ${careClubInfo.hospitalPhoneNumber}</a>`);
                    break;
                case 4 : //Walk-In (TBD)
                    $(wrapper).html(`<a class="btn btn-sky-outline-alt active" href="#">Walk In - TBD</a>`);
                    break;
                case 5 : //corp redirect to FAH
                    $(wrapper).html(`<h5 class="mb-4">Locate a VCA hospital near you and schedule a visit.</h5><a class="btn btn-sky-outline-alt active" href="${careClubInfo.bookAnAppointmentUrl}">Find a Hospital</a>`);
                    break;
            }
        });

    }

    /* function bindAddNewPetBtnClick() {
        $('.js-seciton-step').on('click', 'button.js-add-new-pet', function (e) {
            e.preventDefault();
            var targetValue = $(this).attr('data-target');
            var butonText =  $(this).text().trim();
            careClubInfo.petId = '0';
            careClubInfo.isCareClubMember = '';
            let backStepValue = 'select-pet';
            updateBackBtn(targetValue, backStepValue);
            updateSeciton(targetValue);
        });
    } */

    function bindSelectPetClick() {
        $('.js-seciton-step').on('click', '.js-show-step', function (e) {
            e.preventDefault();
            var wrap = $(this).closest('.js-seciton-step');
            var speciesIdDataVal = $(this).attr('data-value');

            dynamicTitle(wrap);
            wrap.addClass('part-two');
            wrap.find('.js-show-step').not(this).hide();
            wrap.find('.js-vca-dropdown-button').hide();
            wrap.find('.js-shelter-link').hide();
            wrap.find('.js-login-link').hide();
            careClubInfo.petSpecies = $(this).attr('data-type');
            careClubInfo.speciesId = parseInt(speciesIdDataVal);
            careClubInfo.petImgURL = $(this).find('.js-confirm-img').attr('src');
            $(this).addClass('active');
            $(this).closest('section[data-step]').find('button[data-btn="back"]').addClass('btn-reset');
            wrap.find('.js-hidden-step').show();

            //create breed dropdown
            let selectBreedEl = ui.$petInfo.find( "#breed" );
            createEl.populatedBreedsList(careClubInfo.breedsList, selectBreedEl, careClubInfo.speciesId);
        });
    }

    function bindNewClientClick() {
        $('.js-seciton-step').on('click', '.js-contiune-new-user', function (e) {
            e.preventDefault();
           //createNewClient();
           //showLoader();
        });
    }

    function dynamicTitle(wrap) {
        var dynamicTitleWrapper = wrap.find('.js-dynamic-title');
        $(dynamicTitleWrapper).find('.ccde__form__question__title').each((idx,title) => {
            $(title).hide();
        });
        wrap.find('.ccde__form__question__title.-pet-selected').show();
    }

    function resetDynamicTitle() {
        var wrapper = $('.ccde__form__header.js-dynamic-title');
        wrapper.find('.ccde__form__question__title').each((idx,title) => {
            $(title).hide();
        });
        wrapper.find('.ccde__form__question__title.-pet-not-selected').show();
    }

    function bindVerifyUserClick() {
        $('.js-seciton-step').on('click', '.js-verify-user', function (e) {
            e.preventDefault();

            if ($('.js-verify-address-inputs .js-required').val() != '' && $('.js-pet-selector-box input').is(':checked')){
                careClubInfo.addressChallengeAnswer = $("input[name='missingAddress']").val();
                careClubInfo.petNameChallengeAnswer = $("input[name='petName']:checked").val();
                showLoader();
                checkConfirmChallenge();
            }
        });
    }

    function showLoader() {
        ui.$sections.css('opacity', '.3').css('pointer-events', 'none');
        ui.loader.show();
    }

    function hideLoader() {
        ui.$sections.css('opacity', '1').css('pointer-events', 'all');
        ui.loader.hide();
    }

    function clearPetInformation() {
        careClubInfo.petName = '';
        careClubInfo.petGender = '';
        careClubInfo.sexId = '';
        careClubInfo.petSpayed = '';
        careClubInfo.petSpecies = '';
        careClubInfo.speciesId = '';
        careClubInfo.petsAgeYear = '';
        careClubInfo.petsAgeMonth = '';
        careClubInfo.petBreed = '';
        careClubInfo.petBreedId = '';
        careClubInfo.petAge = '';
    }

    function bindExpireMembershipClick() {
        $('.js-expire-membership').on('click', function (e) {
            e.preventDefault();

            let agreementStepIsVisible = ui.$agreement.is(':visible');
            let isAElement = $(this).is('a');
    
            if (agreementStepIsVisible && careClubInfo.planid) {
                fireExpireMembership();
            }

            if (isAElement) {
                let redirectUrl = $(this).attr('href');
                window.location = redirectUrl;
            }
        });
    }

    async function fireExpireMembership() {

        if (!careClubInfo.membershipId) {
            return;
        }

        var params = {
            'HospitalId': careClubInfo.hospitalIDValue,
            'MembershipId': careClubInfo.membershipId
        };

        const { success, data, error }  = await expireMembership.post(params);

        if (!success){
            console.log('failed', error);
            ui.$sections.hide();
            ui.$errorStep.show();
            hideLoader();
            $('.js-error-message').text(error);
            window.VCA.ccdeDatalayer.datalayerPushStepChange(careClubInfo, 'error', 'agreement');
            return;
        }
    }

    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.CareClubForm.init();
});